import axios from 'axios';

export default class MediaService {
    constructor(component) {
        this.component = component;
        this.baseUrl = process.env.NODE_ENV === 'production'
            ? 'https://nextapi.logonomy.ir'
            : 'http://localhost:5051';
    }



    removeFile = (id, module) => {
        return axios.delete(`${this.baseUrl}/api/Media/Delete/${module}/${id}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem("jwt")
            },
        })
            .then(res => res.data).catch(error => {
                this.showError(error);
            });
    }

    showError = (error) => {
        this.component.$toast.add({
            severity: "error",
            summary: error.response.data,
            life: 3000
        });
    }

}
